import { casesActions } from "configs";
import {
  useCurrentCase,
  useParams,
  useDispatch,
  setErrorsFromResponse
} from "duck";
import { Fragments, useUpdateAuthorizationMutation } from "requests";

export const useUpdateAuthorizations = () => {
  const { id } = useParams();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);
  const dispatch = useDispatch();
  const [update] = useUpdateAuthorizationMutation({
    ignoreResults: true
  });

  return (
    authorization: Fragments.StoredMedicalCase["authorizations"][number]
  ) => {
    dispatch(
      casesActions.updateAuthorization({ _id: id, data: authorization })
    );
    if (shouldSync && authorization._id) {
      return update({
        variables: {
          input: { _id: authorization._id, selected: authorization.selected }
        }
      }).catch(error => {
        setErrorsFromResponse(error);
      });
    }
  };
};
